import * as React from 'react';
import HeaderSection from '../../components/HeaderSection';
import View from 'components/View';
import FirstStepsSection from './FirstStepsSection';
import { useAppContext } from 'contexts/app';
import dynamic from 'next/dynamic';
import CTAButton from './CTAButton';
import { useTranslation } from 'next-i18next';

const FaqSection = dynamic(() => import('./FaqSection'));
const FeatureSection = dynamic(() => import('./FeatureSection'));

const SwissLoyaltyCards: React.FC = () => {
  const { creditCard } = useAppContext();
  const { t } = useTranslation();

  return (
    <div className="PoinzCardsContainer">
      {creditCard && (
        <>
          <HeaderSection
            label={t('loyalty.poinzCreditCards') as string}
            title={creditCard?.title}
            description={creditCard?.description}
            ctaButton={<CTAButton className="mt-8" />}
          />
          <FirstStepsSection className="pt-20 md:pt-0" />
          <View className="pt-20 gap-4 flex flex-col flex-1">
            <FeatureSection />
            <FaqSection className="pt-20" />
            <CTAButton className="mt-10 self-center" />
          </View>
        </>
      )}
    </div>
  );
};

SwissLoyaltyCards.displayName = 'SwissLoyaltyCards';

export default SwissLoyaltyCards;
